import type { FC } from 'react';
import { ErrorBoundary } from '../../components';
import { ApiProvider, ClientSettingsProvider, WidgetSettingsProvider } from '../../context';
import ConditionalRenderBasedOnClientSettings from '../../components/ConditionalRenderBasedOnClientSettings';
import { ExperimentationProvider } from '../../context/ExperimentationProvider/ExperimentationProvider';
import type { WidgetSettings } from '../../typings/configuration.types';
import { WidgetContent } from '../../components/WidgetContent/WidgetContent';
import { WidgetContextProvider } from '../../context/WidgetContextProvider/WidgetContextProvider';
import { ErrorProvider } from '../../context/ErrorProvider/ErrorProvider';

export interface IExpressCheckoutProps {
    settings: WidgetSettings;
}

export const ExpressCheckout: FC<IExpressCheckoutProps> = ({ settings }) => {
    return (
        <ErrorBoundary>
            <ErrorProvider>
                <WidgetSettingsProvider.Provider configuration={settings}>
                    <ApiProvider.Provider>
                        <ClientSettingsProvider.Provider>
                            <ConditionalRenderBasedOnClientSettings>
                                <ExperimentationProvider>
                                    <WidgetContextProvider>
                                        <WidgetContent />
                                    </WidgetContextProvider>
                                </ExperimentationProvider>
                            </ConditionalRenderBasedOnClientSettings>
                        </ClientSettingsProvider.Provider>
                    </ApiProvider.Provider>
                </WidgetSettingsProvider.Provider>
            </ErrorProvider>
        </ErrorBoundary>
    );
};
